import { UserAgent, Registerer, SessionState } from "sip.js";
import { retrieveWebPhoneCredentials } from "../services/PhoneServices.js";

const initialModel = {
  namespace: 'phone',

  state: {
    connInfo: {},
    userAgent: null,
    registerer: null,
    phoneSession: null,
  },

  effects: {
    *setFields({ payload }, { call, put, select }) {
      yield put({
        type: 'save',
        payload: payload,
      });
      console.log('  > setFields called', payload);
      return payload;
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload
      };
    }
  },
}

export default initialModel;
